import React, { useState } from "react";
import { connect } from "react-redux";

import PageHeader from "components/layout/page-header/PageHeader";
import { Dashboard }        from "./components/Dashboard";
import { AssignPlanTab }    from "./components/AssignPlanTab";
import { ManageCouponsTab } from "./components/ManageCouponsTab";
import { CreatePlanTab }    from "./components/CreatePlanTab";
import { PlansListTab }    from "./components/PlansListTab";
import { PaymentsHistoryTab } from "./components/PaymentsHistoryTab";
import { useStripeData }    from "./hooks/useStripeData";
import styles from "./stripe-dashboard.module.css";

const TABS = [
  { key: "assign-plan",    label: "Atribuir Plano",   icon: "fas fa-user-tag"    },
  { key: "manage-coupons", label: "Gerenciar Cupons",  icon: "fas fa-ticket-alt"  },
  { key: "create-plans",   label: "Criar Planos",      icon: "fas fa-layer-group" },
  { key: "list-plans",     label: "Planos Existentes", icon: "fas fa-list"        },
  { key: "payments-history", label: "Pagamentos",      icon: "fas fa-receipt"     },
];

const StripeDashboard = ({ token }) => {
  const [activeTab, setActiveTab] = useState("assign-plan");

  const {
    users,
    plans,
    coupons,
    loading,
    error,
    refreshCoupons,
    refreshPlans,
  } = useStripeData(token);

  if (loading) {
    return (
      <div className={styles.loadingWrap}>
        <div className={styles.spinner} />
        <span>Carregando dados...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorWrap}>
        <i className="fas fa-exclamation-circle" /> {error}
      </div>
    );
  }

  return (
    <div className={styles.pageContainer}>
      <PageHeader
        title="Dashboard Stripe"
        subtitle="Gerencie planos, assinaturas e cupons."
        accent="Administração"
      />

      <Dashboard token={token} />

      <div className={styles.divider} />

      <div className={styles.tabBar}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            className={`${styles.tabBtn} ${activeTab === tab.key ? styles.tabBtnActive : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            <i className={tab.icon} /> {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {activeTab === "assign-plan" && (
          <AssignPlanTab users={users} plans={plans} token={token} />
        )}
        {activeTab === "manage-coupons" && (
          <ManageCouponsTab
            initialCoupons={coupons}
            token={token}
            onCouponChange={refreshCoupons}
          />
        )}
        {activeTab === "create-plans" && (
          <CreatePlanTab token={token} onPlanCreated={refreshPlans} />
        )}
        {activeTab === "list-plans" && (
          <PlansListTab plans={plans} users={users} token={token} onRefresh={refreshPlans} />
        )}
        {activeTab === "payments-history" && (
          <PaymentsHistoryTab users={users} plans={plans} token={token} />
        )}
      </div>
    </div>
  );
};

export default connect(state => ({ token: state.auth.accessToken }))(StripeDashboard);
